import { render, staticRenderFns } from "./01_curtain_drape.vue?vue&type=template&id=6e2c2754&scoped=true&"
import script from "./01_curtain_drape.vue?vue&type=script&lang=js&"
export * from "./01_curtain_drape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2c2754",
  null
  
)

export default component.exports